var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-box",attrs:{"id":"mapContainer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }